/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * {Document Title}
 * {Description}
 */

( function( window, $ ) {
	'use strict';
	var document = window.document;

    var openCloseBreadcrumbs = {

        init: function() {
            $(document).on('click', '.breadcrumbs-toggle', function(e){
                $(this).parent('.breadcrumbs').toggleClass("open");
            });
        }

    };

    $(document).ready(function(){
        openCloseBreadcrumbs.init();
    });

} )(window,jQuery);
